export default function PlanTile({ plan, selected, onSelect }) {
  return (
    <div
      className={`plan-tile ${selected ? "selected" : ""}`}
      onClick={onSelect}
    >
      <div className="tile-title">
        {plan.name} {plan.badge && <span>{plan.badge}</span>}
      </div>

      <div className="tile-price">
        <span className="original">₹{plan.original}</span>
        <span className="price">₹{plan.price}</span>
      </div>
    </div>
  );
}